import { UIState } from './state';
import {
  isMobile,
  isSmallScreen,
  isLaptop,
  isTablet,
} from '@components/styles';
import { Theme } from './types';

const theme: Theme = (localStorage.getItem('trac.theme') as Theme) || 'light';

export const uiInitialState: UIState = {
  errors: {},
  loading: {},
  theme,
  dialogs: {},
  snackbar: {},
  snackbarStatus: {},
  mobile: isMobile(),
  tablet: isTablet(),
  smallScreen: isSmallScreen(),
  laptop: isLaptop(),
  showBackdrop: false,
  bottomMenuOpened: false,
  toastNotification: {
    label: '',
    value: undefined,
    type: undefined,
  },
};
